const notificationConfig = {
  deleteConfirmText:
    'This action will delete the following Timed Message Request',
  note: 'NOTE: The timed message once deleted will not be retrieved',

  templatePattern: {
    setDefault:
      'This action will set the selected Template Pattern as the default for all associated partners',
    listAll:
      'This action will list the Template Pattern for all associated partners',
  },
};

export default notificationConfig;
